import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './InputPassword.css'

export default class InputPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sendAvailable: false,
        }
    }

    submit() {
        let { value } = this.password

        if (value.length > 0) {
            this.props.sendPassword(this.password.value)
        }
    }

    onKeyPress(event) {
        if (event.keyCode === 13) {
            if (this.state.sendAvailable) {
               this.submit()
               return false
            }
        }
    }

    onChange(event) {
        let { value } = this.password
        if (value.length > 0 && !this.state.sendAvailable) {
            this.setState({
                sendAvailable: true,
            })
        } else if (value.length === 0 && this.state.sendAvailable) {
            this.setState({
                sendAvailable: false,
            })
        }
    }

    render() {
        return (
            <div className="InputPassword">
                <section className="PasswordNoti">
                    <div className="CheckPassword" hidden={!this.props.checkPassword}>
                        <span>Check Password Please</span>
                    </div>
                </section>
                <section className="PasswordArea">
                    <section>
                        <img className="Unlocked" src={require('../image/ico_unlocked.png')} alt="unlock" />
                    </section>
                    <span className="Unlocked">잠금문서입니다. 패스워드를 입력해주세요.</span>
                    <section>
                        <input ref={(c) => this.password = c} type="password" className="PasswordInput" onKeyPress={(e) => this.onKeyPress(e.nativeEvent)} onChange={(e) => this.onChange(e.nativeEvent)} />
                    </section>
                    <button className="PasswordButton" type="button" onClick={() => this.submit()} disabled={!this.state.sendAvailable}>잠금해제</button>
                </section>
            </div>
        )
    }
}

InputPassword.propTypes = {
    sendPassword: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/InputPassword.js